import { Helmet } from 'react-helmet';
import Layout from '../Layout';

const Bridging = () => {
    return ( 
        <Layout>
             <Helmet> 
                <meta
                    name="description"
                    content="We offer the best bridging and shorts courses in the country."
                />
                <title>Short and Bridging Courses</title>
            </Helmet>
            <div className="light-bg pt-6">
                <div className="custom-container">
                    <div>
                        <div className="row">
                            <div className="col s12 m8 l5 mb-4 mt-4">
                                <p className="grey-text text-darken-2 is-size-6 has-text-weight-semibold ">
                                    The Management of LLEC in partnership with NMC TUTORIALS has published a Comprehensive List of SHORT COURSES and BRIDGING COURSES currently underway at their institution.
                                </p>
                                <h5 className="is-size-4 has-text-weight-semibold mt-5 mb-2">Bridging Courses</h5>
                                <div className="divider"></div>
                                <p className="grey-text text-darken-2 is-size-6 mt-4">
                                    For those with at least 3 Ordinary Level subjects but without passes in either Mathematics, Science and/or English Language.
                                </p>
                                <p className="grey-text text-darken-2 is-size-6 mt-5">
                                    For those willing to restart and sit for at least 5 Ordinary Level subjects for the November 2021 and/or June 2022 ZIMSEC Examinations.
                                </p>
                            </div>
                            <div className="col s12 m8 l6 offset-l1">
                                <h5 className="is-size-4 has-text-weight-semibold mb-2">Aldult Classes</h5>
                                <div className="divider"></div>
                                <p className="grey-text text-darken-2 is-size-6 mt-4">
                                    For any adult willing to upgrade his/her academic profile.
                                </p>

                                <h5 className="is-size-4 has-text-weight-semibold mt-5 mb-2">Mode of study</h5>
                                <div className="divider"></div>
                                <p className="main-color-text mt-3 small-text">
                                    Day and Evening, including weekends.
                                </p>
                                <p className="grey-text text-darken-2 is-size-6 mt-4">
                                    Your enrolment into our bridging courses automatically entails that you become a bona fide student of our Polytechnic School , ( if you wish to enrol at the Polytechnic School ) , upon passing your Bridging Course(s). 
                                </p>
                            </div>
                        </div>
                        <div className="topic-cont mb-5">
                            <span className="is-size-6-touch is-size-5-desktop grey-text text-lighten-3">Short Courses</span>
                        </div>
                        <div className="row">
                            <div className="col s12 m8 l4">
                                <ul className="collection with-header z-depth-1 mt-5">
                                    <li className="collection-header is-size-5 has-text-weight-semibold main-color-text">APPLIED ARTS AND SCIENCE</li>
                                    <li className="collection-item">FABRIC DYEING, BATIK AND PRINTING</li>
                                    <li className="collection-item">COMPUTER APPLICATIONS</li>
                                    <li className="collection-item">VIDEOGRAPHY</li>
                                    <li className="collection-item">GUITAR, MBIRA AND VOCALS COACHING</li>
                                    <li className="collection-item">SIGN WRITING</li>
                                    <li className="collection-item">THEATRE AND ARTS</li>
                                    <li className="collection-item">GRAPHIC DESIGNING</li>
                                    <li className="collection-item">WEB DEVELOPMENT</li>
                                    <li className="collection-item">MUSIC STUDIO ENGINEERING & MASTERING</li>
                                    <li className="collection-item">PHOTOGRAPHY</li>
                                    <li className="collection-item">ONLINE TUTORING CONTENT CREATION SKILLS</li>
                                    <li className="collection-item">FASHION DESIGN</li>
                                </ul>
                            </div>
                            <div className="col s12 m8 l4">
                                <ul className="collection with-header z-depth-1 mt-5">
                                    <li className="collection-header is-size-5 has-text-weight-semibold main-color-text">CIVIL AND CONSTRUCTION</li>
                                    <li className="collection-item">URBAN DESIGN</li>
                                    <li className="collection-item">AUTOCAD FOR BEGINNERS</li>
                                    <li className="collection-item">ARCHITECTURAL DRAUGHTSMANSHIP </li>
                                </ul>
                                <ul className="collection with-header z-depth-1 mt-5">
                                    <li className="collection-header is-size-5 has-text-weight-semibold main-color-text">ENGINEERING</li>
                                    <li className="collection-item">SOFTWARE ENGINEERING</li>
                                    <li className="collection-item">COMPUTER MAINTENANCE & REPAIRS</li>
                                    <li className="collection-item">TELEVISION & RADIO MAINTENANCE & REPAIRS</li>
                                    <li className="collection-item">CELLPHONE REPAIRS</li>
                                </ul>
                            </div>
                            <div className="col s12 m8 l4">
                                <ul className="collection with-header z-depth-1 mt-5">
                                    <li className="collection-header is-size-5 has-text-weight-semibold main-color-text">COMMERCE</li>
                                    <li className="collection-item">BASIC BUSINESS MANAGEMENT</li>
                                    <li className="collection-item">PROPERTY VALUATION 1 AND 2</li>
                                    <li className="collection-item">PROPERTY MANAGEMENT</li>
                                    <li className="collection-item">PROPERTY SALES AND MANAGEMENT</li>
                                    <li className="collection-item">PROJECT MANAGEMENT</li>
                                    <li className="collection-item">MONITORING AND EVALUATION</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
     );
}
 
export default Bridging;